import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TokenService } from '@cargos/sprintpay-services';
import { Observable } from 'rxjs';
import { catchError, distinctUntilChanged, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private tokenService: TokenService,
        private router: Router
    ) {}

    getCurrentToken(): Observable<string> {
        return this.tokenService.getCurrentToken$().pipe(distinctUntilChanged());
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.getCurrentToken().pipe(
            take(1),
            map((token) => !!token || this.router.parseUrl('/')),
            catchError(() => {
                return this.router.navigate(['/']);
            })
        );
    }
}
